import React from 'react';
import { Alert } from 'react-bootstrap';
import { DeviceFrameset } from 'react-device-frameset';
import 'react-device-frameset/styles/marvel-devices.min.css';

function SmsPreview({ message }) {
    if (!message) {
        return (
            <Alert variant="warning" className="mb-0">
                No SMS message available for this campaign.
            </Alert>
        );
    }

    return (
        <div className="d-flex justify-content-center py-3">
            <DeviceFrameset device="iPhone X">
                <div
                    style={{
                        marginTop: '100px',
                        marginLeft: '30px',
                        padding: '15px',
                        display: 'inline-block',
                        position: 'relative',
                        width: '300px',
                        height: 'auto',
                        backgroundColor: 'lightyellow',
                        borderRadius: '30px',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                    }}
                >
                    {message}
                </div>
            </DeviceFrameset>
        </div>
    );
}

export default SmsPreview;
